import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { Interview3QuestionComponent } from './interview3-question.component';

import { SharedModule } from '../shared/shared.module';

@NgModule({
  declarations: [
    Interview3QuestionComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
  ],
  providers: [

  ]
})
export class Interview3QuestionModule { }
